/* tslint:disable */
/* eslint-disable */
/**
 * Metaform REST API
 * REST API for Metaform
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReplySummaryOption
 */
export interface ReplySummaryOption {
    /**
     * 
     * @type {string}
     * @memberof ReplySummaryOption
     */
    value?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplySummaryOption
     */
    label?: string;
    /**
     * 
     * @type {number}
     * @memberof ReplySummaryOption
     */
    count?: number;
}

export function ReplySummaryOptionFromJSON(json: any): ReplySummaryOption {
    return ReplySummaryOptionFromJSONTyped(json, false);
}

export function ReplySummaryOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReplySummaryOption {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : json['value'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'count': !exists(json, 'count') ? undefined : json['count'],
    };
}

export function ReplySummaryOptionToJSON(value?: ReplySummaryOption | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
        'label': value.label,
        'count': value.count,
    };
}


